import React from "react";

/**
 * Delete confirmation component for Layer
 * Displays a confirmation dialog before deleting a layer
 */
const Delete = ({ formData, handleSubmit, onDiscard }) => {
  const layerName = formData?.layer_name || "this item";

  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this record?{" "}
        <b>
          <u>Layer: {layerName}</u>
        </b>
      </h3>

      <div className="mt-4">
        <button
          type="button"
          className="btn bg-orange form-btn"
          onClick={handleSubmit}
          aria-label={`Confirm delete ${layerName}`}
        >
          Yes
        </button>
        <button
          type="button"
          className="btn btn-secondary form-btn mx-3"
          onClick={onDiscard}
          aria-label="Cancel delete"
        >
          No
        </button>
      </div>
    </div>
  );
};

export default Delete;
